import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';

export default {
  namespaced: true,
  state: {
    is_sending: false,
    error_sending: null,
    sent: null
  },
  mutations: {
    is_sending(state, payload) {
      state.is_sending = payload;
    },
    error_sending(state, payload) {
      state.error_sending = payload;
    },
    sent(state, payload) {
      state.sent = payload
    }
  },
  actions: {
    send({commit}, payload) {
      commit('is_sending', true);
      firebase.analytics().logEvent('generate_lead', { value: 'Contact Form' });
      
      var contactUs = firebase.functions().httpsCallable('contactUs');
      contactUs({
        emailAddress: payload.emailAddress,
        name: payload.name,
        subject: payload.subject,
        message: payload.message,
        subscribe: payload.subscribe
      })
      .then(() => {    
        commit('error_sending', null);
        commit('is_sending', false);
        commit('sent', true);
      })
      .catch(error => {
        commit('error_sending', error);
        commit('is_sending', false);
        commit('sent', false);
      })
    }
  },
  getters: {
    // NOTE: Apparently getters are not getters/setter style and should be used for filtering only.
    //        Access properties directly from code instead.
    is_sending(state) {
      return state.is_sending;
    },
    error_sending(state) {
      return state.error_sending
    },
    sent(state) {
      return state.sent
    }
  }
}

export const types = {
  mutations: {
    // commit
    ERROR_SENDING: 'Message/error_sending',
  },
  actions: {
    // dispatch
    SEND_MESSAGE: 'Message/send'
  },
  getters: {
    IS_SENDING: 'Message/is_sending',
    SENT: 'Message/sent',
    ERROR_SENDING: 'Message/error_sending'
  }
}